import {
    Box as UiBox,
    L2RButton,
    Modal,
    styled,
} from "@l2r-front/l2r-ui"

const BUTTON_SIZE = 44

export const FabButton = styled(L2RButton)(({ theme }) => ({
    "&.MuiIconButton-root": {
        border: "none",
        boxShadow: theme.customShadow("LCS/Shadow-simple"),
        width: BUTTON_SIZE,
        height: BUTTON_SIZE,
    },
}))

export const Popup = styled(Modal)(({ theme }) => ({
    backgroundColor: theme.palette["common/white_states"].main,
    width: "100%",
    height: "100%",
}))

export const Box = styled(UiBox)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    position: "relative",
    padding: theme.spacing(6),
    height: "100%",
}))